import clsx from "clsx";

const Navigation = ({ activeStep, maxPossibleStep, steps, onChange }) => {
  return (
    <section className="tabs is-detached is-first has-text-align-center">
      <nav className="tabs-nav">
        <ul className="nav-items" role="tablist">
          {steps.map(({ step, name }, index) => (
            <li key={`step-${index}`} className="nav-item" role="presentation">
              <button
                type="button"
                onClick={() => onChange(step)}
                className={clsx("nav-link", activeStep === step && "is-active")}
                disabled={step > maxPossibleStep}
                role="tab"
              >
                {name}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </section>
  );
};

export default Navigation;
